import axios from "axios";
import cookie from "react-cookies";

const apiEndpoint = process.env.ENDPOINT;

// Define a generic type for the API instance
const axiosInstance = axios.create({
  baseURL: apiEndpoint,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor Request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = cookie.load("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
